// extracted by mini-css-extract-plugin
export default {"flipTransition":"customStyle_flipTransition__u+R3f","flip":"customStyle_flip__KA+sW"};